import { useState } from 'react';
import i18n from 'i18next';

import { FfpCheckTraveller, useCheckFfpStatusQuery } from '@websky/graphql';
import { useConfig } from '../../../../context';

const useFfpStatusCheck = () => {
	const { checkFfpStatus: isEnabled } = useConfig().Engine;

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const { refetch: fetchFfpStatusCheck } = useCheckFfpStatusQuery({ skip: true });

	const checkFfpStatus = async (travellers: FfpCheckTraveller[]): Promise<Record<string, string> | null> => {
		if (!travellers.length) {
			return null;
		}

		setIsLoading(true);

		try {
			const { data } = await fetchFfpStatusCheck({ params: travellers });

			setIsLoading(false);

			if (data?.CheckFfpStatus?.some(result => !result.success)) {
				const errors: Record<string, string> = {};

				data.CheckFfpStatus.forEach(result => {
					if (!result.success) {
						errors[result.travellerId] = i18n.t(result.errorMsg, {
							ns: 'Passenger',
							nsSeparator: '|',
							keySeparator: '>'
						});
					}
				});

				if (travellers.length === 1) {
					setError(errors[travellers[0].travellerId] ?? Object.values(errors)[0]);
				}

				return errors;
			}

			setError(null);

			return null;
		} catch (e) {
			setIsLoading(false);

			throw e;
		}
	};

	return { checkFfpStatus, isLoading, isEnabled, error };
};

export default useFfpStatusCheck;
